import { take, put, fork, all, call } from 'redux-saga/effects';
import { StaticToast } from 'src/components/common';
import { fetchJson } from 'src/utils/fetch';
import { MedicineType } from './type';

function* add_prescription_to_chart() {
  while (true) {
    const action = yield take(MedicineType.ADD_PRESCRIPTION_TO_CHART);
    try {
      const { payload, callback } = action;
      yield put({ type: MedicineType.ADD_PRESCRIPTION_TO_CHART, payload });
      typeof callback === 'function' && callback();
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}
function* select_patient_item() {
  while (true) {
    const action = yield take(MedicineType.SELECT_PATIENT_ITEM);
    try {
      const { payload, callback } = action;
      yield put({ type: MedicineType.SELECT_PATIENT_ITEM, payload });
      typeof callback === 'function' && callback();
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}
function* fetch_patient() {
  while (true) {
    const action = yield take(MedicineType.FETCH_PATIENT);
    try {
      const { callback, payload } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/patient/detail',
        type: 'POST',
        data: payload,
        isloading: true,
      });
      if (res && res.code === '0') {
        yield put({ type: MedicineType.SELECT_PATIENT_ITEM, payload: res.result });
        // if (res.result && res.result.length === 0) {
        //   yield put({ type: MedicineType.CLEAR_SELECT_PATIENT_ITEM });
        // }

        typeof callback === 'function' && callback();
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}
function* submit_prescription() {
  while (true) {
    const action = yield take(MedicineType.SUBMIT_PRESCRIPTION);
    try {
      const { payload: { patientInfo, illness, ...rest }, callback } = action;
      // 不再请求接口，生成处方ID。直接把处方药信息保存redux，然后通过订单接口进行提交
      yield put({
        type: MedicineType.SUBMIT_PRESCRIPTION_SUCCESS,
        payload: {
          ...rest,
          patientInfo,
        },
      });
      yield put({ type: MedicineType.UPDATE_ILLENESS, payload: illness });
      typeof callback === 'function' && callback();
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

export default function* root() {
  yield all([fork(add_prescription_to_chart)]);
  yield all([fork(select_patient_item)]);
  yield all([fork(fetch_patient)]);
  yield all([fork(submit_prescription)]);
}
